import React, { useEffect, useState } from "react";
import WorkOrder from "../../workOrder";
import "../index.css";
import { Card, Spin, message } from "antd";
import { BiExport } from "react-icons/bi";
import Cookies from "universal-cookie";
import ModalData from "./content";
import { loaderReducer } from "../../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import moment from "moment";
import AppointmentActionsLite from "../Appointment/AppointmentActions";

const Index = ({
  tranId,
  apptStatus,
  priority,
  reconciliationStatus,
  specialInstructions,
  techName,
  isRefresh,
}) => {
  const [completedTasks, setCompletedTasks] = useState([]);
  const [IncompleteTasks, setInCompleteTasks] = useState([]);
  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();

  //open pop-up
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [individualTask, setIndividualTask] = useState(false);
  const [isVisibleTech, setIsVisibleTech] = useState(false);
  const [activeEdit, setActiveEdit] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [customFields, setCustomFields] = useState({});

  // NEW: Add loading and error states
  const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);
  const [answerFetchError, setAnswerFetchError] = useState(null);

  // NEW: Validate environment variable
  const API_BASE_URL = process.env.REACT_APP_API;

  // NEW: Safe localStorage access with error handling
  const getLocalUserData = () => {
    try {
      const userData = localStorage.getItem("userData");
      if (!userData) {
        console.warn("[Index] No userData found in localStorage");
        return null;
      }
      return JSON.parse(userData);
    } catch (error) {
      console.error("[Index] Error parsing userData from localStorage:", error);
      return null;
    }
  };

  const localData = getLocalUserData();

  // NEW: Validate token before making API calls
  const validateToken = () => {
    if (!token) {
      console.error("[Index] No authentication token found");
      message.error("Authentication token missing. Please log in again.");
      return false;
    }
    return true;
  };

  // NEW: Validate API URL
  const validateAPIUrl = () => {
    if (!API_BASE_URL) {
      console.error("[Index] REACT_APP_API environment variable is not set");
      message.error("API configuration error. Please contact support.");
      return false;
    }
    return true;
  };

  // IMPROVED: showModal with proper async handling
  const showModal = async (task) => {
    console.log("[Index] Opening modal for task:", task);

    // Validate task has required fields
    if (!task || !task._id) {
      console.error("[Index] Invalid task object:", task);
      message.error("Invalid task data");
      return;
    }

    setSelectedTask(task);
    setIsModalOpen(true);
    setAnswerFetchError(null); // Reset error state

    // Fetch answers asynchronously
    await fetchAnswers(task._id);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    // NEW: Reset states on modal close
    setCustomFields({});
    setAnswerFetchError(null);
    setIsLoadingAnswers(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    // NEW: Reset states on modal close
    setCustomFields({});
    setAnswerFetchError(null);
    setIsLoadingAnswers(false);
  };

  const handleClickTech = () => {
    setIsVisibleTech(!isVisibleTech);
  };

  const handleActiveEdit = () => {
    if (localData?.role === "user") {
      setActiveEdit(true);
    }
  };

  useEffect(() => {
    handleActiveEdit();
  }, [activeEdit]);

  // IMPROVED: fetchAnswers with comprehensive error handling
  // ✅ CORRECTED fetchAnswers function for your parent component (Index.jsx)
  // Replace your existing fetchAnswers function with this
  // ✅ COMPLETE fetchAnswers function with FUZZY MATCHING
  // Replace your entire fetchAnswers function in your parent component (Index.jsx)

  const fetchAnswers = async (taskId) => {
    // Validate inputs
    if (!API_BASE_URL) {
      console.error("[Index] REACT_APP_API not set");
      message.error("API configuration error");
      return;
    }

    if (!token) {
      console.error("[Index] No authentication token");
      message.error("Authentication token missing");
      return;
    }

    if (!taskId) {
      console.error("[Index] fetchAnswers called without taskId");
      setAnswerFetchError("Task ID is missing");
      return;
    }

    console.log("[Index] Fetching answers for taskId:", taskId);
    setIsLoadingAnswers(true);
    setAnswerFetchError(null);

    try {
      const url = `${API_BASE_URL}/answer/individual/${taskId}`;
      console.log("[Index] Fetching from URL:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("[Index] Response status:", response.status, response.statusText);

      // Check if response is OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error("[Index] API error response:", errorText);

        if (response.status === 401) {
          message.error("Session expired. Please log in again.");
        } else if (response.status === 404) {
          console.warn("[Index] No answers found for taskId:", taskId);
          setAnswerFetchError("No answers found for this task");
        } else if (response.status === 500) {
          message.error("Server error. Please try again later.");
          setAnswerFetchError("Server error occurred");
        } else {
          message.error(`Error fetching answers: ${response.status}`);
          setAnswerFetchError(`Error: ${response.status} ${response.statusText}`);
        }

        setIsLoadingAnswers(false);
        return;
      }

      // Parse response
      const data = await response.json();
      console.log("[Index] Raw API response:", data);

      // Validate response structure
      if (!data || data.status !== "success") {
        console.error("[Index] Unexpected response format:", data);
        setAnswerFetchError("Invalid response from server");
        setIsLoadingAnswers(false);
        return;
      }

      // ✅ Debug logs for closing questions
      console.log("=== CLOSING QUESTION DEBUG ===");
      console.log("Survey Title:", data.surveyTemplate?.title);
      console.log("Survey Type:", data.surveyTemplate?.jobType);
      console.log("Answer Count:", data.answer?.answer?.length);
      console.log("Is closing question?:",
        data.surveyTemplate?.title?.toLowerCase().includes("closing"));

      // ✅ Extract nested answer object
      const answerObj = data.answer || {};
      const surveyTemplate = data.surveyTemplate || null;

      console.log("[Index] Answer object:", answerObj);
      console.log("[Index] Survey template:", surveyTemplate);
      console.log("[Index] Answers array:", answerObj.answer);

      // ✅ Get the answers array from nested structure
      let answersArray = [];

      if (answerObj.answer && Array.isArray(answerObj.answer)) {
        answersArray = answerObj.answer;
      } else {
        console.warn("[Index] No answers array found in response");
      }

      console.log("[Index] Original answers count:", answersArray.length);

      // ✅✅ IMPROVED UUID MAPPING WITH FUZZY MATCHING ✅✅
      if (answersArray.length > 0 && surveyTemplate?.customSurvey) {
        console.log("[Index] Mapping answer UUIDs to template UUIDs...");

        answersArray = answersArray.map(ans => {
          // Try exact match first
          let matchingQuestion = surveyTemplate.customSurvey.find(q => {
            return q.question === ans.question || q.foot_photo === ans.question;
          });

          // ✅ If no exact match, try FUZZY MATCHING
          if (!matchingQuestion) {
            const answerText = (ans.question || "").toLowerCase().trim();

            // Extract key words from answer question
            const answerKeyWords = answerText
              .replace(/[?.,!]/g, "") // Remove punctuation
              .split(" ")
              .filter(word => word.length > 3); // Keep words longer than 3 chars

            console.log(`[Index] 🔍 Trying fuzzy match for: "${ans.question}"`);
            console.log(`[Index] Key words:`, answerKeyWords);

            // Find template question with most matching keywords
            let bestMatch = null;
            let bestMatchScore = 0;

            surveyTemplate.customSurvey.forEach(q => {
              const templateText = (q.question || q.foot_photo || "").toLowerCase().trim();

              // Count how many keywords match
              const matchCount = answerKeyWords.filter(word =>
                templateText.includes(word)
              ).length;

              // Also check for similar question patterns
              const isSimilarPattern =
                (answerText.includes("successfully") && templateText.includes("successfully")) ||
                (answerText.includes("unable") && templateText.includes("unable")) ||
                (answerText.includes("why") && templateText.includes("why")) ||
                (answerText.includes("did you") && templateText.includes("did you"));

              const score = matchCount + (isSimilarPattern ? 1 : 0);

              if (score > bestMatchScore && score >= 2) { // Require at least 2 matches
                bestMatch = q;
                bestMatchScore = score;
              }
            });

            if (bestMatch) {
              matchingQuestion = bestMatch;
              console.log(`[Index] ✅ Fuzzy matched to: "${matchingQuestion.question || matchingQuestion.foot_photo}"`);
              console.log(`[Index] Match score: ${bestMatchScore}`);
            }
          }

          if (matchingQuestion) {
            if (ans.uuid !== matchingQuestion.uuid) {
              console.log(`[Index] ✅ Mapped "${ans.question}"`);
              console.log(`  - From UUID: ${ans.uuid}`);
              console.log(`  - To UUID:   ${matchingQuestion.uuid}`);
            }

            return {
              ...ans,
              uuid: matchingQuestion.uuid,  // Use template's UUID
              question: ans.question  // Keep original question text for display
            };
          } else {
            console.warn(`[Index] ⚠️ No matching question found for: "${ans.question}"`);
            console.warn(`[Index] This answer will not be displayed in the modal`);
            return ans; // Keep original (will be filtered out)
          }
        });

        console.log("[Index] Mapped answers count:", answersArray.length);

        // ✅ Check how many answers couldn't be mapped
        const unmappedCount = answersArray.filter(ans => {
          const isInTemplate = surveyTemplate.customSurvey.some(q => q.uuid === ans.uuid);
          return !isInTemplate;
        }).length;

        if (unmappedCount > 0) {
          console.warn(`[Index] ⚠️ ${unmappedCount} answer(s) could not be mapped and may be hidden`);
        }
      } else {
        console.log("[Index] Skipping UUID mapping (no answers or no template)");
      }

      console.log("[Index] Final answers to set:", answersArray);

      // ✅ Set custom fields with MAPPED answers
      const customFieldsData = {
        answer: answersArray,              // ← Mapped answers with correct UUIDs
        surveyTemplate: surveyTemplate,
        surveyId: answerObj.surveyId,
        userId: answerObj.userId,
        _id: answerObj._id,
        deleted: answerObj.deleted,
        createdAt: answerObj.createdAt,
        updatedAt: answerObj.updatedAt
      };

      console.log("[Index] Setting customFields:", {
        answerCount: customFieldsData.answer?.length || 0,
        hasTemplate: !!customFieldsData.surveyTemplate,
        hasSurveyId: !!customFieldsData.surveyId
      });

      setCustomFields(customFieldsData);

      console.log("[Index] ✅ Custom fields set successfully");

    } catch (error) {
      console.error("[Index] ❌ Error fetching answers for taskId:", taskId, error);

      if (error.name === "TypeError" && error.message.includes("fetch")) {
        message.error("Network error. Please check your connection.");
        setAnswerFetchError("Network error - please check your connection");
      } else if (error.name === "SyntaxError") {
        console.error("[Index] JSON parsing error:", error);
        message.error("Invalid response from server");
        setAnswerFetchError("Invalid server response");
      } else {
        message.error("Failed to load answers. Please try again.");
        setAnswerFetchError(error.message || "Unknown error occurred");
      }
    } finally {
      setIsLoadingAnswers(false);
    }
  };

  // IMPROVED: fetchTasks with better error handling
  useEffect(() => {
    const fetchTasks = async () => {
      if (!validateAPIUrl() || !validateToken()) {
        return;
      }

      if (!tranId) {
        console.warn("[Index] fetchTasks called without tranId");
        return;
      }

      dispatch(loaderReducer(true));
      console.log("[Index] Fetching tasks for tranId:", tranId);

      try {
        const url = `${API_BASE_URL}/task/task-by-tran-id-admin/${tranId}`;
        console.log("[Index] Fetching tasks from URL:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("[Index] Tasks response status:", response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error("[Index] Error fetching tasks:", errorText);

          if (response.status === 401) {
            message.error("Session expired. Please log in again.");
          } else if (response.status === 404) {
            console.warn("[Index] No tasks found for tranId:", tranId);
          } else {
            message.error("Failed to load tasks");
          }

          setCompletedTasks([]);
          setInCompleteTasks([]);
          dispatch(loaderReducer(false));
          return;
        }

        const data = await response.json();
        console.log("[Index] Tasks data received:", data);

        // Validate data structure
        if (data && data.data) {
          setCompletedTasks(data.data.taskCompleted || []);
          setInCompleteTasks(data.data.taskInCompleted || []);
        } else {
          console.warn("[Index] Unexpected tasks data structure:", data);
          setCompletedTasks([]);
          setInCompleteTasks([]);
        }

        dispatch(loaderReducer(false));
      } catch (error) {
        console.error("[Index] Error fetching tasks for tranId:", tranId, error);

        if (error.name === "TypeError" && error.message.includes("fetch")) {
          message.error("Network error loading tasks");
        } else {
          message.error("Failed to load tasks");
        }

        setCompletedTasks([]);
        setInCompleteTasks([]);
        dispatch(loaderReducer(false));
      }
    };

    fetchTasks();
  }, [tranId, isRefresh, token, API_BASE_URL]);

  // IMPROVED: generateCSV with error handling
  const generateCSV = async () => {
    if (!validateAPIUrl() || !validateToken()) {
      return null;
    }

    const headers = [
      "Survey Result ID",
      "Order ID",
      "Tech",
      "Serial Number",
      "Was Product 1 installed/serviced",
      "Date Survey Submitted",
    ];

    try {
      const url = `${API_BASE_URL}/task/export-items/${tranId}`;
      console.log("[Index] Exporting CSV from URL:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error("[Index] CSV export error:", response.status);
        message.error("Failed to export CSV");
        return null;
      }

      const data = await response.json();

      // Validate data structure
      if (!data || !data.data || !data.data.tasks) {
        console.error("[Index] Invalid CSV data structure:", data);
        message.error("Invalid export data");
        return null;
      }

      const tasks = data.data.tasks;

      const rows = tasks.map((task) => [
        "Generated by App",
        tranId,
        data.data.techName || "null",
        task.serialNumber || "null",
        task.isCompleted || "null",
        moment(task.updatedAt).format("MM/DD/YYYY") || "null",
      ]);

      const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
      return csvContent;
    } catch (error) {
      console.error("[Index] Error generating CSV for tranId:", tranId, error);
      message.error("Failed to generate CSV");
      return null;
    }
  };

  const downloadCSV = async () => {
    console.log("[Index] Starting CSV download");
    const csvContent = await generateCSV();

    if (!csvContent) {
      console.error("[Index] CSV content is empty");
      return;
    }

    try {
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `tasks_${tranId}_${moment().format("YYYYMMDD")}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
      message.success("CSV downloaded successfully");
    } catch (error) {
      console.error("[Index] Error downloading CSV:", error);
      message.error("Failed to download CSV");
    }
  };

  return (
    <div>
      <div className="PSbtn mt-2">
        <div
          className="priorbtn"
          style={{
            backgroundColor:
              priority === "Low"
                ? "#C2CDDD"
                : priority === "High"
                  ? "#F47E75"
                  : priority === "Medium"
                    ? "#4585B2"
                    : priority === "Urgent"
                      ? "#FF3535"
                      : "#414C60",
            color: "#FFF",
          }}
        >
          PRIORITY: {priority}
        </div>
        <div
          className="priorbtn"
          style={{
            backgroundColor:
              apptStatus === "onhold"
                ? "#FFB23E"
                : apptStatus === "rejected"
                  ? "#FF3535"
                  : apptStatus === "scheduled"
                    ? "#4585B2"
                    : apptStatus === "completed"
                      ? "#84d504"
                      : apptStatus === "pending"
                        ? "#C2CDDD"
                        : apptStatus === "rescheduled"
                          ? "#4585B2"
                          : "#414C60",
            color: "#FFF",
          }}
        >
          APPOINTMENT STATUS: {apptStatus}
        </div>
        <div
          className="priorbtn"
          style={{
            backgroundColor:
              reconciliationStatus === "Completed"
                ? "#84d504"
                : reconciliationStatus === "Order Fix Needed"
                  ? "#F47E75"
                  : reconciliationStatus === "In Progress"
                    ? "#4585B2"
                    : reconciliationStatus === "Not Started"
                      ? "#FFB23E"
                      : reconciliationStatus === "Reviewed"
                        ? "#15e64c"
                        : "#414C60",
            color: "#FFF",
          }}
        >
          RECONCILIATION STATUS: {reconciliationStatus}
        </div>
      </div>

      <div>
        <div className="PSbtn mt-2">
          <AppointmentActionsLite tranId={tranId} />
        </div>
      </div>

      <div className="tupdate mt-4">Incomplete Items</div>
      <div>
        {IncompleteTasks?.length === 0
          ? "No Data found"
          : IncompleteTasks &&
          IncompleteTasks.map((data) => (
            <Card
              hoverable
              style={{ marginTop: "1rem" }}
              key={data._id || data.id} // Use _id if available
              onClick={() => showModal(data)}
            >
              <div className="position-relative">
                <div className="sub2head">{data.title}</div>
                <div style={{ paddingRight: "1rem" }}>{data.device}</div>
                <div style={{ paddingRight: "1rem" }}>
                  {data.serialNumber}
                </div>
                <div style={{ paddingRight: "1rem" }}>Room : {data.room}</div>
                <img src="/images/arrow.png" alt="" className="arrowCls" />
              </div>
            </Card>
          ))}
        <div className="tupdate mt-4">Completed Items</div>
        {completedTasks?.length === 0
          ? "No Data found"
          : completedTasks &&
          completedTasks.map((data) => (
            <Card
              hoverable
              style={{ marginTop: "1rem" }}
              key={data._id || data.id} // Use _id if available
              onClick={() => showModal(data)}
            >
              <div className="position-relative">
                <div className="sub2head">{data.title}</div>
                <div style={{ paddingRight: "1rem" }}>{data.device}</div>
                <div style={{ paddingRight: "1rem" }}>
                  {data.serialNumber}
                </div>
                <div style={{ paddingRight: "1rem" }}>Room : {data.room}</div>
                <img src="/images/arrow.png" alt="" className="arrowCls" />
              </div>
            </Card>
          ))}
        <div className="d-flex justify-content-end">
          <div className="contd mt-4" onClick={downloadCSV}>
            Export Items as CSV
            <BiExport style={{ fontSize: "20px" }} />
          </div>
        </div>
      </div>

      {/* IMPROVED: Pass loading and error states to modal */}
      <ModalData
        arg={{
          isModalOpen,
          handleOk,
          handleCancel,
          handleActiveEdit,
          individualTask,
          isVisibleTech,
          activeEdit,
          selectedTask,
          specialInstructions,
          techName,
          tranId,
          customFields,
          setCustomFields,
          reconciliationStatus,
          isLoadingAnswers, // NEW: Pass loading state
          answerFetchError, // NEW: Pass error state
        }}
      />
    </div>
  );
};

export default Index;
